import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCommerceList(params) {
  return request({
    url: URL.mdm.basicData.commerce,
    method: 'get',
    params
  })
}

export function getAllRegionList() {
  return request({
    url: URL.mdm.basicData.commerces,
    method: 'get'
  })
}

export function queryCommerceDetail(uuid) {
  return request({
    url: URL.mdm.basicData.queryCommerceDetail + '?uuid=' + encodeURIComponent(uuid),
    method: 'get'
  })
}

export function saveCommerce(data) {
  return request({
    url: URL.mdm.basicData.commerce,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCommerce(uuid) {
  return request({
    url: URL.mdm.basicData.commerce + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
